angular.module("digiexam.gradingMatrix", [
	"dx.webapp.navigation",
	"digiexam.services",
]);
